import { useCallback, useEffect, useState } from "react";
import { useSubAssemblyService } from "../../../../services/subAssemblyService";
import { LandingGearTypeCatalogItem } from "../../../../types/subAssembly";

export function useLandingGearTypes(airframeFamily?: string) {
  const { getLandingGearCatalog } = useSubAssemblyService();
  const [landingGearTypes, setLandingGearTypes] = useState<LandingGearTypeCatalogItem[]>(
    []
  );
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!airframeFamily?.trim()) {
      setLandingGearTypes([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const catalog = await getLandingGearCatalog(airframeFamily);
      setLandingGearTypes(
        catalog.map((entry) => ({
          type: entry.positionCode,
          label: entry.label,
          allowedSubAssemblyTypes: entry.allowedSubAssemblyTypes,
        }))
      );
    } catch {
      setLandingGearTypes([]);
    } finally {
      setLoading(false);
    }
  }, [airframeFamily, getLandingGearCatalog]);

  useEffect(() => {
    void load();
  }, [load]);

  return { landingGearTypes, loading, reload: load };
}
